export interface WorklistQueryParams {
  orderId: number | null
  startDate: number | null
  endDate: number | null
  search: string | null
  siteId: number | null
  state: string | null
  patientId: number | null
  patientIds: number[] | null
}

export const parseWorklistParams = (
  params: Record<string, string>,
): WorklistQueryParams => ({
  orderId: params.orderId ? Number(params.orderId) : null,
  startDate: params.startDate ? Number(params.startDate) : null,
  endDate: params.endDate ? Number(params.endDate) : null,
  search: params.search || null,
  siteId: params.siteId ? Number(params.siteId) : null,
  state: params.state || null,
  patientId: params.patientId ? Number(params.patientId) : null,
  patientIds: params.patientIds
    ? params.patientIds.split(',').map(Number).filter(Boolean)
    : null,
})
